import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Input from "../../components/atoms/Input";
import CategoryFilter from "../../components/molecures/CategoryFilter";
import PageFilter from "../../components/molecures/PageFilter";
import CustomCollapse from "../../components/organisms/Collapse";
import useDidChangetEffect from "../../hooks/useDidChangeEffect";
import { HttpError } from "../../network/types";
import { Option } from "../../shared/interface";
import { alertError } from "../../shared/utils";
import { getFaqCategories, getFAQList } from "../../apis/Faq/apis";
import { FaqListItem } from "../../apis/Faq/apis/types";

const FAQ: React.FC = () => {
  const { search } = useLocation();
  const nav = useNavigate();
  const searchParams = new URLSearchParams(search);

  const location = useLocation();

  const [rows, setRows] = useState<FaqListItem[]>([]);
  const [categories, setCategories] = useState<Option[]>();
  const [totalCount, setTotalCount] = useState<number>(0);

  const DEFAULT_PAGE = 1;
  const DEFAULT_PAGE_SIZE = 10;
  const QUERY_KEY_FILTER = "filter";
  const QUERY_KEY_PAGE = "page";
  const QUERY_KEY_PAGE_SIZE = "pageSize";

  const getPaginationInfoFromQuery = () => {
    try {
      const pageInQuery = searchParams.get(QUERY_KEY_PAGE) || `${DEFAULT_PAGE}`;
      const filterValues = JSON.parse(
        searchParams.get(QUERY_KEY_FILTER) ||
          JSON.stringify({
            faqCategoryId: categories
              ? categories.find((val) => val.label === "전체")?.value
              : 7,
          })
      );
      const pageSizeInQuery =
        searchParams.get(QUERY_KEY_PAGE_SIZE) || `${DEFAULT_PAGE_SIZE}`;
      const page = parseInt(pageInQuery, 10);
      const pageSize = parseInt(pageSizeInQuery, 10);

      return {
        page,
        pageSize,
        filterValues,
      };
    } catch (e) {
      return {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        filterValues: {},
      };
    }
  };
  const { page, pageSize, filterValues } = getPaginationInfoFromQuery();
  const getCategoriesMutation = useMutation(getFaqCategories, {
    onSuccess: (res) => {
      setCategories(
        res.rows.map((val) => ({ label: val.categoryName, value: val.id }))
      );
      pushPage(1, 10, {
        ...filterValues,
        faqCategoryId:
          res.rows?.find((val) => val.categoryName === "전체")?.id || 7,
      });
    },
    onError: (err: HttpError) => {
      setCategories([]);
      if (err.status !== 404) alertError(err.message);
    },
  });
  const getPageListMutation = useMutation(getFAQList, {
    onSuccess: (res) => {
      setRows(
        res.faqList.map((val) => ({
          ...val,
          group: val.faqCategory?.categoryName || val.group || "-",
        }))
      );
      setTotalCount(res.count || 0);
    },
    onError: (err: HttpError) => {
      if (err.status !== 404) alertError(err.message);
      setRows([]);
    },
  });

  const [searchText, setSearchText] = useState<string>(
    filterValues.question || ""
  );
  const pushPage = (page: number, pageSize: number, filterValues = {}) => {
    const { pathname } = location;
    const filterString = JSON.stringify(filterValues);

    const queryString = new URLSearchParams({
      page: `${page}`,
      pageSize: `${pageSize}`,
      [QUERY_KEY_FILTER]: filterString,
    }).toString();
    const nextUrl = `${pathname}?${queryString}`;
    nav(nextUrl);
  };

  const handlePaginationChange = (page: number) => {
    pushPage(page, pageSize, filterValues);
  };
  useEffect(() => {
    setSearchText(filterValues.question || "");
  }, [filterValues.question]);
  useEffect(() => {
    getCategoriesMutation.mutate({ isUsedEvery: true, viewable: true });
  }, []);
  useDidChangetEffect(() => {
    getPageListMutation.mutate({
      page,
      pageSize,
      ...filterValues,
    });
  }, [location]);
  return (
    <>
      <PageFilter
        title="FAQ"
        smallPageTitle="고객센터"
        inputs={[
          <InputWrapper key={`FAQInput${1}`}>
            <Input
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onPressEnter={() =>
                pushPage(1, pageSize, {
                  ...filterValues,
                  question: searchText,
                })
              }
              placeholder="검색어를 입력해주세요"
            />
          </InputWrapper>,
        ]}
        margin="0 0 24px 0px"
      />
      <StyledSectionWrapper>
        <CategoryFilter
          nowCategory={filterValues.faqCategoryId}
          categoryArray={categories || []}
          setCategory={(e) => {
            pushPage(1, pageSize, {
              ...filterValues,
              question: "",
              faqCategoryId: e,
            });
          }}
        />

        <CustomCollapse
          data={rows || []}
          isLoading={getPageListMutation.isLoading}
          title="FAQ 리스트"
          onPageChagned={handlePaginationChange}
          currentPage={page || 1}
          currentPageSize={pageSize}
          totalCount={totalCount || 0}
        />
      </StyledSectionWrapper>
    </>
  );
};

export default FAQ;

const InputWrapper = styled.div``;
const StyledSectionWrapper = styled.div`
  background-color: white;
  margin: 40px 0px 0px 0px;
  border-radius: 16px;
  overflow-y: hidden;
`;
